if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      constructor() {
        super();

        this.shortText = this.querySelector('.read-more__short');
        this.fullText = this.querySelector('.read-more__full');
        this.readMoreButton = this.querySelector('.read-more__button--more');
        this.readLessButton = this.querySelector('.read-more__button--less');

        this.readMoreButton?.addEventListener('click', this.handleClick.bind(this, 'more'));
        this.readLessButton?.addEventListener('click', this.handleClick.bind(this, 'less'));
      }

      /**
       * @param {String} type
       */
      handleClick(type) {
        if (type === 'more') {
          this.shortText?.setAttribute('aria-hidden', 'true');
          this.fullText?.removeAttribute('aria-hidden');
          this.readLessButton?.removeAttribute('aria-hidden');
          this.readMoreButton?.setAttribute('aria-hidden', 'true');
          gtag('event', 'pdp_engagements', {
            'event_action': 'read_more',
          });
        } else {
          this.shortText?.removeAttribute('aria-hidden');
          this.fullText?.setAttribute('aria-hidden', 'true');
          this.readLessButton?.setAttribute('aria-hidden', 'true');
          this.readMoreButton?.removeAttribute('aria-hidden');
        }
      }
    },
  );
}
